<template>
  <div class="HeaderTop">
    <div @click="changeCollapse" class="collapse">
      <transition name="el-zoom-in-center">
        <i v-show="collapse" class="el-icon-s-unfold"></i>
      </transition>
      <transition name="el-zoom-in-center">
        <i v-show="!collapse" class="el-icon-s-fold"></i>
      </transition>
    </div>

    <div class="HeaderBox">
      <span class="UserNameStyle">{{ CompanyName }}&nbsp;&nbsp;</span>
      <!-- <el-dropdown :hide-on-click="false" @command="changeTheme">
        <span class="el-dropdown-link" @click="changeTheme">
          <i class="el-header-right" :class="isDark ? 'ri-sun-fill' : 'ri-moon-fill'"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item class="el-icon-width"><i class="el-header-right"
              :class="isDark ? 'ri-check-line' : ''"></i>亮色模式</el-dropdown-item>
          <el-dropdown-item class="el-icon-width"><i class="el-header-right"
              :class="isDark ? '' : 'ri-check-line'"></i>暗黑模式</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->

      <el-dropdown @command="handleCommand" trigger="click">
        <span class="el-dropdown-link" @click="top = !top">
          <span class="UserNameStyle">{{ UserName }}</span><i class="el-header-right"
            :class="{ 'el-icon-caret-bottom': !top, 'el-icon-caret-top': top }"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="modifPwd">修改密码</el-dropdown-item>
          <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <div>
        <ModifPwd :item="pwd"></ModifPwd>
      </div>
    </div>
  </div>
</template>


<script>
import ModifPwd from "@/components/ModifPwd.vue";
export default {
  components: {
    ModifPwd,
  },
  data() {
    return {
      theme: "light",
      UserName: "",
      CompanyName: "",
      top: false,
      pwd: {},
    };
  },
  computed: {
    isDark() {
      return this.theme == "light";
    },
    collapse() {
      return this.$store.state.IsCollapse;
    },
  },
  mounted() {
    this.$get("User/GetUserInfo").then((r) => {
      this.UserName = r.Result.Username;
      this.CompanyName = r.Result.CompanyName;
      this.handleUser(r.Result);
    });
    this.theme = localStorage.getItem("data-theme") || "light";
    this.$nextTick(() => {
      window.document.documentElement.setAttribute("data-theme", this.theme);
    });
  },
  methods: {
    changeCollapse() {
      this.$store.commit("changeCollapse");
    },
    changeTheme() {
      this.theme = this.theme == "light" ? "dark" : "light";
      window.document.documentElement.setAttribute("data-theme", this.theme);
      localStorage.setItem("data-theme", this.theme);
    },
    handleCommand(command) {
      switch (command) {
        case "loginOut":
          sessionStorage.clear();
          window.location.reload();
          break;
        case "modifPwd":
          this.pwd = {};
          break;
      }
    },
    handleUser(userinfo) {
      // let PasswordVaild = this.$dayjs(userinfo.PasswordVaildDate)
      //   .subtract(7, "day")
      //   .isBefore(this.$dayjs(), "day");
      // if (PasswordVaild) {
      //   this.$alert("密码有效期小于7天，请尽快修改密码", "系统提示", {
      //     confirmButtonText: "确定",
      //     callback: (action) => {
      //       this.pwd = {};
      //     },
      //   });
      // } else 
      if (userinfo.IsDefultPwd) {
        this.$alert("您的密码还是默认密码，请尽快修改密码", "系统提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            this.pwd = {};
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.HeaderTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .collapse {
    margin-left: 15px;
    font-size: 25px;
    cursor: pointer;
  }
}

.HeaderBox {
  display: flex;
  align-items: center;
}

.el-dropdown-menu--small .el-dropdown-menu__item {
  line-height: 28px;
  padding: 0 15px;
  font-size: 14px;
}

.el-icon-width {
  display: flex;
  align-items: center;

  i {
    display: block;
    width: 12px;
  }
}
</style>